/* The Fluffy Claw – behaviour for the Fluffy sections in Horizon.
   Loaded as a module (deferred, never blocks the first paint).
   Add to cart talks to Horizon's cart drawer through Shopify's standard cart events. */
(function () {
  'use strict';

  var reduceMotion = Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function qsa(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  /* ---------------------------------------------------------------
     Add to cart → Horizon cart drawer + cart bubble
     --------------------------------------------------------------- */
  function routes() {
    var r = (window.Theme && window.Theme.routes) || {};
    return { add: r.cart_add_url || '/cart/add.js', cart: r.cart_url || '/cart' };
  }

  function addToCart(source, formData, quantity) {
    var urls = routes();
    var sectionIds = qsa(document, 'cart-items-component')
      .map(function (el) { return el.dataset.sectionId; })
      .filter(Boolean);
    if (sectionIds.length) {
      formData.append('sections', sectionIds.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    return import('@shopify/events')
      .catch(function () { return null; })
      .then(function (events) {
        var CartLinesUpdateEvent = events && events.CartLinesUpdateEvent;
        var deferred = null;
        if (CartLinesUpdateEvent && typeof CartLinesUpdateEvent.createPromise === 'function') {
          deferred = CartLinesUpdateEvent.createPromise();
          source.dispatchEvent(
            new CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: String(formData.get('id')), quantity: quantity }],
              promise: deferred.promise,
            })
          );
        }

        return fetch(urls.add, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        })
          .then(function (response) { return response.json(); })
          .then(function (result) {
            return fetch(urls.cart + '.json', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
              .then(function (response) { return response.json(); })
              .catch(function () { return null; })
              .then(function (cart) {
                var failed = Boolean(result && result.status);
                if (deferred) {
                  deferred.resolve({
                    cart: cart ? CartLinesUpdateEvent.createCartFromAjaxResponse(cart) : undefined,
                    detail: {
                      items: cart ? cart.items : [],
                      source: 'fc-product',
                      sourceId: source.dataset.section || '',
                      itemCount: quantity,
                      sections: failed ? undefined : result.sections,
                      didError: failed,
                    },
                  });
                }
                if (failed) return { error: result.description || result.message || 'Error' };
                var hasDrawer = Boolean(document.querySelector('cart-drawer-component'));
                return { handled: Boolean(deferred && hasDrawer) };
              });
          })
          .catch(function (error) {
            if (deferred) deferred.reject(error);
            throw error;
          });
      });
  }

  /* ---------------------------------------------------------------
     Buy box: variants, quantity, gallery, buy bar
     --------------------------------------------------------------- */
  if (!customElements.get('fc-product')) {
    customElements.define(
      'fc-product',
      class FcProduct extends HTMLElement {
        connectedCallback() {
          if (this._ready) return;
          this._ready = true;

          var data = this.querySelector('[data-fc-variants]');
          try {
            this.variants = data ? JSON.parse(data.textContent) : [];
          } catch (e) {
            this.variants = [];
          }

          this.form = this.querySelector('form[data-type="add-to-cart-form"]');
          this.idInput = this.form ? this.form.querySelector('input[name="id"]') : null;
          this.qtyInput = this.querySelector('[data-fc-qty]');
          this.qtyMax = this.qtyInput ? Number(this.qtyInput.max) || 99 : 1;
          this.atc = this.querySelector('[data-fc-atc]');
          this.atcText = this.querySelector('[data-fc-atc-text]');
          this.atcPrice = this.querySelector('[data-fc-atc-price]');
          this.atcPriceWrap = this.querySelector('[data-fc-atc-price-wrap]');
          this.atcQty = this.querySelector('[data-fc-atc-qty]');
          this.errorEl = this.querySelector('[data-fc-error]');
          this.track = this.querySelector('[data-fc-track]');
          this.sticky = this.querySelector('[data-fc-sticky]');
          this.labels = {
            add: this.dataset.addLabel || 'Add to cart',
            soldOut: this.dataset.soldOutLabel || 'Sold out',
          };

          var currentId = this.idInput ? Number(this.idInput.value) : 0;
          this.current =
            this.variants.find(function (v) { return v.id === currentId; }) || this.variants[0];
          this.selected = this.current ? this.current.options.slice() : [];

          this.addEventListener('click', this.onClick.bind(this));
          if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
          if (this.qtyInput) {
            var self = this;
            this.qtyInput.addEventListener('change', function () {
              self.setQuantity(self.qtyInput.value);
            });
          }

          this.initGallery();
          this.initSticky();
          if (this.current && this.current.media) this.goToMedia(this.current.media, false);
          this.setQuantity(this.qtyInput ? this.qtyInput.value : 1);
          this.syncExternal();
        }

        onClick(event) {
          var option = event.target.closest('[data-fc-option]');
          if (option && this.contains(option)) {
            this.selectOption(Number(option.dataset.fcOption), option.dataset.value);
            return;
          }
          var step = event.target.closest('[data-fc-qty-step]');
          if (step && this.contains(step)) {
            this.setQuantity(this.quantity() + Number(step.dataset.fcQtyStep));
            return;
          }
          var slide = event.target.closest('[data-fc-step]');
          if (slide && this.contains(slide)) {
            this.stepMedia(Number(slide.dataset.fcStep));
            return;
          }
          if (event.target.closest('[data-fc-sticky-atc]')) this.submit();
        }

        quantity() {
          return this.qtyInput ? Math.max(1, parseInt(this.qtyInput.value, 10) || 1) : 1;
        }

        setQuantity(value) {
          var qty = Math.min(this.qtyMax, Math.max(1, parseInt(value, 10) || 1));
          if (this.qtyInput) this.qtyInput.value = String(qty);
          var self = this;
          qsa(this, '[data-fc-qty-step]').forEach(function (button) {
            var dir = Number(button.dataset.fcQtyStep);
            button.disabled = dir < 0 ? qty <= 1 : qty >= self.qtyMax;
          });
          this.updateButtons();
        }

        selectOption(index, value) {
          if (!this.variants.length) return;
          var selected = this.selected.slice();
          selected[index] = value;
          var match = this.variants.find(function (v) {
            return v.options.every(function (o, k) { return o === selected[k]; });
          });
          if (!match) {
            match =
              this.variants.find(function (v) { return v.options[index] === value && v.available; }) ||
              this.variants.find(function (v) { return v.options[index] === value; });
          }
          if (match) this.setVariant(match);
        }

        setVariant(variant) {
          var self = this;
          this.current = variant;
          this.selected = variant.options.slice();

          if (this.idInput) {
            this.idInput.value = variant.id;
            this.idInput.disabled = false;
            this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          qsa(this, '[data-fc-option]').forEach(function (b) {
            b.setAttribute('aria-pressed', String(self.selected[Number(b.dataset.fcOption)] === b.dataset.value));
          });
          qsa(this, '[data-fc-option-label]').forEach(function (el) {
            el.textContent = self.selected[Number(el.dataset.fcOptionLabel)] || '';
          });
          qsa(this, '[data-fc-price]').forEach(function (el) { el.innerHTML = variant.price; });
          qsa(this, '[data-fc-compare]').forEach(function (el) {
            el.innerHTML = variant.compare || '';
            el.hidden = !variant.compare;
          });
          qsa(this, '[data-fc-sticky-variant]').forEach(function (el) {
            el.textContent = variant.label ? variant.label + ' · ' : '';
          });
          var stickyImg = this.querySelector('[data-fc-sticky-thumb] img');
          if (stickyImg && variant.image) {
            stickyImg.removeAttribute('srcset');
            stickyImg.src = variant.image;
          }

          this.updateButtons();
          if (variant.media) this.goToMedia(variant.media, true);

          if (this.dataset.updateUrl === 'true' && window.history && window.history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());
          }

          this.syncExternal();
        }

        updateButtons() {
          var v = this.current;
          if (!v) return;
          var self = this;
          var qty = this.quantity();

          if (this.atc) this.atc.disabled = !v.available;
          if (this.atcText) this.atcText.textContent = v.available ? this.labels.add : this.labels.soldOut;
          if (this.atcPrice) this.atcPrice.innerHTML = v.price;
          if (this.atcPriceWrap) this.atcPriceWrap.hidden = !v.available;
          if (this.atcQty) {
            this.atcQty.textContent = qty > 1 ? qty + ' × ' : '';
            this.atcQty.hidden = qty < 2;
          }

          qsa(this, '[data-fc-sticky-atc]').forEach(function (b) {
            b.disabled = !v.available;
            b.textContent = v.available ? self.labels.add : self.labels.soldOut;
          });
        }

        submit() {
          if (!this.form || !this.atc || this.atc.disabled) return;
          if (typeof this.form.requestSubmit === 'function') this.form.requestSubmit(this.atc);
          else this.atc.click();
        }

        onSubmit(event) {
          event.preventDefault();
          var self = this;
          if (!this.atc || this.atc.disabled || this.busy) return;
          this.busy = true;
          this.showError('');
          this.atc.classList.add('is-loading');
          this.atc.setAttribute('aria-busy', 'true');

          var formData = new FormData(this.form);
          var quantity = this.quantity();
          formData.set('quantity', String(quantity));

          addToCart(this, formData, quantity)
            .then(function (result) {
              if (result.error) self.showError(result.error);
              else if (!result.handled) window.location.href = routes().cart;
              else self.flashAdded();
            })
            .catch(function () {
              window.location.href = routes().cart;
            })
            .then(function () {
              self.busy = false;
              self.atc.classList.remove('is-loading');
              self.atc.removeAttribute('aria-busy');
            });
        }

        showError(message) {
          if (!this.errorEl) return;
          this.errorEl.textContent = message || '';
          this.errorEl.hidden = !message;
        }

        flashAdded() {
          var self = this;
          var label = this.atc && this.atc.dataset.addedLabel;
          if (!label || !this.atcText) return;
          this.atcText.textContent = label + ' ✓';
          clearTimeout(this._addedTimer);
          this._addedTimer = setTimeout(function () { self.updateButtons(); }, 1800);
        }

        syncExternal() {
          var selected = this.selected;
          qsa(document, '[data-fc-select-value]').forEach(function (el) {
            var on = selected[Number(el.dataset.fcSelectIndex || 0)] === el.dataset.fcSelectValue;
            if (el.tagName === 'BUTTON') el.setAttribute('aria-pressed', String(on));
            el.classList.toggle('is-selected', on);
          });
        }

        initGallery() {
          var self = this;
          if (!this.track) return;
          this.slides = qsa(this.track, '[data-media-id]');
          this.dots = qsa(this, '[data-fc-dot]');
          this.activeIndex = 0;
          if (!('IntersectionObserver' in window) || this.slides.length < 2) return;

          var observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                  self.markActive(entry.target.dataset.mediaId);
                } else {
                  qsa(entry.target, 'video').forEach(function (video) { video.pause(); });
                }
              });
            },
            { root: this.track, threshold: [0, 0.6] }
          );
          this.slides.forEach(function (slide) { observer.observe(slide); });
        }

        markActive(id) {
          var index = (this.slides || []).findIndex(function (s) { return s.dataset.mediaId === String(id); });
          if (index >= 0) this.activeIndex = index;
          (this.dots || []).forEach(function (dot) {
            dot.classList.toggle('is-active', dot.dataset.fcDot === String(id));
          });
        }

        stepMedia(direction) {
          if (!this.slides || !this.slides.length) return;
          var count = this.slides.length;
          var next = (this.activeIndex + direction + count) % count;
          this.goToMedia(this.slides[next].dataset.mediaId, true);
        }

        goToMedia(id, smooth) {
          if (!this.track) return;
          var slide = this.track.querySelector('[data-media-id="' + id + '"]');
          if (!slide) return;
          this.track.scrollTo({ left: slide.offsetLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
          this.markActive(id);
        }

        /* Buy bar: visible while the real buy button is scrolled above the screen.
           Checked once per frame on scroll, so jumps (anchor links, tap on the status bar) are handled too. */
        initSticky() {
          var sticky = this.sticky;
          var atc = this.atc;
          if (!sticky || !atc) return;
          sticky.inert = true;
          var shown = false;
          var ticking = false;
          var update = function () {
            ticking = false;
            var show = atc.getBoundingClientRect().bottom < 0;
            if (show === shown) return;
            shown = show;
            sticky.classList.toggle('is-visible', show);
            sticky.inert = !show;
            sticky.setAttribute('aria-hidden', String(!show));
          };
          window.addEventListener(
            'scroll',
            function () {
              if (ticking) return;
              ticking = true;
              window.requestAnimationFrame(update);
            },
            { passive: true }
          );
          update();
        }
      }
    );
  }

  /* Shade tiles anywhere on the page select the variant in the buy box */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-fc-select-value]');
    if (!trigger) return;
    var product = document.querySelector('fc-product');
    if (!product || typeof product.selectOption !== 'function') return;
    event.preventDefault();
    product.selectOption(Number(trigger.dataset.fcSelectIndex || 0), trigger.dataset.fcSelectValue);
    if (trigger.hasAttribute('data-fc-scroll')) {
      product.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }
  });

  /* Links to this product in the page content (e.g. the hero button) scroll to the buy box
     instead of loading the product page again. Menu and footer links behave normally. */
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest('a[href]');
    if (!link || link.target === '_blank' || !link.closest('main')) return;
    var product = document.querySelector('fc-product[data-handle]');
    if (!product || product.closest('dialog')) return;
    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (error) {
      return;
    }
    if (url.origin !== window.location.origin) return;
    if (!/\/products\/[^/]+\/?$/.test(url.pathname)) return;
    if (url.pathname.replace(/\/$/, '').split('/').pop() !== product.dataset.handle) return;
    event.preventDefault();
    product.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------------------------------------------------------------
     Reels: posters load near the screen, videos play when visible
     --------------------------------------------------------------- */
  if (!customElements.get('fc-reels')) {
    customElements.define(
      'fc-reels',
      class FcReels extends HTMLElement {
        connectedCallback() {
          if (this._ready) return;
          this._ready = true;
          var self = this;
          var reels = qsa(this, '[data-fc-reel]');

          var loadPosters = function () {
            qsa(self, 'video[data-fc-poster]').forEach(function (video) {
              video.poster = video.getAttribute('data-fc-poster');
              video.removeAttribute('data-fc-poster');
            });
          };
          if ('IntersectionObserver' in window) {
            var posterObserver = new IntersectionObserver(
              function (entries) {
                if (entries.some(function (entry) { return entry.isIntersecting; })) {
                  loadPosters();
                  posterObserver.disconnect();
                }
              },
              { rootMargin: '600px 0px' }
            );
            posterObserver.observe(this);
          } else {
            loadPosters();
          }

          reels.forEach(function (reel) {
            var video = reel.querySelector('video');
            var toggle = reel.querySelector('[data-fc-reel-toggle]');
            if (!video) return;
            video.muted = true;
            video.playsInline = true;
            video.loop = true;
            video.addEventListener('play', function () {
              reel.classList.add('is-playing');
              if (toggle) toggle.setAttribute('aria-label', toggle.dataset.labelPause || 'Pause');
            });
            video.addEventListener('pause', function () {
              reel.classList.remove('is-playing');
              if (toggle) toggle.setAttribute('aria-label', toggle.dataset.labelPlay || 'Play');
            });
            if (toggle) {
              toggle.addEventListener('click', function () {
                if (video.paused) {
                  reel.dataset.userPaused = 'false';
                  video.play().catch(function () {});
                } else {
                  reel.dataset.userPaused = 'true';
                  video.pause();
                }
              });
            }
          });

          if (reduceMotion || !('IntersectionObserver' in window)) return;
          var observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                var video = entry.target.querySelector('video');
                if (!video) return;
                if (entry.isIntersecting && entry.target.dataset.userPaused !== 'true') video.play().catch(function () {});
                else video.pause();
              });
            },
            { threshold: 0.6 }
          );
          reels.forEach(function (reel) { observer.observe(reel); });
        }
      }
    );
  }

  /* ---------------------------------------------------------------
     Country and language selects in the footer switch right away
     --------------------------------------------------------------- */
  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('select[data-fc-autosubmit]');
    if (select && select.form) select.form.submit();
  });

  /* ---------------------------------------------------------------
     Delivery estimate in the shopper's language (skips weekends)
     --------------------------------------------------------------- */
  function addBusinessDays(date, days) {
    var result = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      var day = result.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return result;
  }

  function initDelivery(root) {
    qsa(root || document, '[data-fc-delivery]').forEach(function (el) {
      var min = Number(el.dataset.min || 0);
      var max = Math.max(min, Number(el.dataset.max || 0));
      var lang = document.documentElement.lang || undefined;
      var options = { weekday: 'short', day: 'numeric', month: 'short' };
      var format;
      try {
        format = new Intl.DateTimeFormat(lang, options);
      } catch (e) {
        format = new Intl.DateTimeFormat(undefined, options);
      }
      var now = new Date();
      var first = format.format(addBusinessDays(now, min));
      var last = format.format(addBusinessDays(now, max));
      el.textContent = first === last ? first : first + ' – ' + last;
      var wrap = el.closest('[data-fc-delivery-wrap]');
      if (wrap) wrap.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initDelivery(document); });
  } else {
    initDelivery(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initDelivery(event.target);
  });
})();
